import Vue from 'vue'
import Vuex from 'vuex'
import utils from '../common/js/util'
import {getAdminInfo} from '@/api/getData'

Vue.use(Vuex);

const state = {
    adminInfo: {
        avatar: 'default.jpg'
    },
    currentSellerId: JSON.parse(utils.doSessionStorage("get", "currentSellerId")) || null,
    permissions: JSON.parse(utils.doSessionStorage("get", "permissions")) || [],
};

const getters = {
    getCurrentSellerId: (state) => () => {
        if (state.currentSellerId) {
            return state.currentSellerId.id;
        } else {
            return utils.getUserSellerId();
        }
    },
    getCurrentSeller: state => {
        return state.currentSellerId;
    },

    permissions: state => state.permissions
};

const mutations = {
    saveAdminInfo(state, adminInfo) {
        state.adminInfo = adminInfo;
    },
    setCurrentSellerId(state, params) {
        state.currentSellerId = params;
    },
    setPermissions: (state, permissions) => {
        state.permissions = permissions
    }
};

const actions = {
    async getAdminData({commit}) {
        /*try{
            const res = await getAdminInfo()
            if (res.status == 1) {
                commit('saveAdminInfo', res.data);
            }else{
                throw new Error(res)
            }
        }catch(err){
            console.log('您尚未登陆或者session失效')
        }*/
    },
    setCurrentSellerId(context, params) {
        context.commit("setCurrentSellerId", params);
    }
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js